<template>
  <div>
    <h1>{{ $t("travelService.chooseOfferForm.title") }}</h1>
    <v-stepper non-linear v-if="offer != null" v-model="stepper">
      <v-stepper-header>
        <template v-for="(item, itemIndex) in offer.items">
          <v-stepper-step :rules="[() => stepValidation(item)]" :step="itemIndex + 1" editable error-icon="fa-edit" :key="item.id">
            <b>{{ $t("travelService.types." + item.type) }}</b>
            <small v-if="stepValidation(item) !== true">{{ $t("travelService.chooseOfferForm.formIncomplete") }} </small>
          </v-stepper-step>
          <v-divider :key="-1 * item.id" />
        </template>
        <v-stepper-step :step="offer.items.length + 1" editable error-icon="fa-edit">
          <b>{{ $t("global.summary") }}</b>
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content :key="item.id" :step="itemIndex + 1" v-for="(item, itemIndex) in offer.items">
          <v-form :ref="'form' + itemIndex" v-model="item.isValid">
            <div :key="offer.id" v-for="(offer, offerIndex) in item.offers">
              <fieldset class="custom-fieldset">
                <legend>
                  {{ $t("travelService.chooseOfferForm.option") }}
                  {{ offerIndex + 1 }}
                </legend>
                <v-row>
                  <v-col md="10" v-if="offer.html != null && offer.html.length !== 0">
                    <w-y-s-i-w-y-g-html-element :html="offer.html" />
                  </v-col>
                  <v-col md="10" v-if="item.type === 'hotel' && (offer.html == null || offer.html.length === 0)" cols="12">
                    <hotel-response-presentation :offer="offer"> </hotel-response-presentation>
                  </v-col>
                  <v-col md="10" v-if="item.type === 'car' && (offer.html == null || offer.html.length === 0)" cols="12">
                    <car-response-presentation :offer="offer" />
                  </v-col>
                  <v-col md="10" v-if="item.type === 'flight' && (offer.html == null || offer.html.length === 0)" cols="12">
                    <flight-response-presentation :offer="offer" />
                  </v-col>
                  <v-col md="10" v-if="item.type === 'rail' && (offer.html == null || offer.html.length === 0)" cols="12">
                    <rail-response-presentation :offer="offer" />
                  </v-col>
                  <v-col class="pl-3" md="2" cols="12">
                    <v-text-field :label="$t('global.amount')" :value="offer.price + ' ' + offer.currency" outlined readonly />
                    <v-radio-group :mandatory="false" v-model="item.selectedOffer" @click="validateThisItemForm(item)">
                      <v-radio :label="$t('travelService.chooseOfferForm.chooseThis')" :value="offer.id" />
                    </v-radio-group>
                  </v-col>
                </v-row>
              </fieldset>
            </div>

            <ClientViewOfferHistory :offers="item.offers" />

            <fieldset class="custom-fieldset">
              <legend>{{ $t("travelService.additionalQuestions") }}</legend>
              <message-list :travel-service-order-item-id="item.id" :travel-service-order-id="$route.params.id" :start-messages="item.messages" />
            </fieldset>

            <v-row>
              <v-col class="pr-3" md="10" cols="12">
                <v-alert color="grey darken-2" class="text-justify" outlined>
                  {{ $t("travelService.chooseOfferForm.cancelRequest.firstPart") }}
                  <router-link :to="'/travel-service/edit/' + $route.params.id">{{ $t("travelService.chooseOfferForm.cancelRequest.linkPart") }}</router-link>
                  {{ $t("travelService.chooseOfferForm.cancelRequest.thirdPart") }}
                  "<span class="font-weight-bold">{{ $t("travelService.chooseOfferForm.cancelRequest.boldPart") }}</span
                  >". {{ $t("travelService.separatePart") }}
                  <a href="#" @click.prevent="SeparateTravelService($route.params.id)">{{ $t("travelService.separateLink") }}</a
                  >.
                </v-alert>
              </v-col>
              <v-col class="pl-1" md="2" cols="12">
                <v-radio-group :mandatory="false" @click="item.returnSelectedOffer = 0" v-model="item.selectedOffer">
                  <v-radio :label="$t('travelService.chooseOfferForm.cancelRequest.radioLabel')" :value="0" />
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row v-if="item.selectedOffer !== null && item.selectedOffer !== 0">
              <travel-users-inline-form
                :available-users="availableUsers"
                :required-props="getRequiredProps(item)"
                :users="item.users"
                @saved="downloadAvailableUsers"
              />

              <v-col v-if="$store.state.Auth.userProperties.system_settings.cost_centre_on_delegations !== settingTypes.NOT_AVAILABLE" cols="12">
                <fieldset class="custom-fieldset">
                  <legend>
                    {{ $t("travelService.chooseOfferForm.costCentreFullName") }}
                  </legend>
                  <v-tooltip top>
                    <template #activator="{on}">
                      <v-combobox :items="costCentres" :rules="costCentresRules" v-on="on" v-model="item.cost_centre">
                        <div slot="append">
                          <v-icon>fa-info-circle</v-icon>
                        </div>
                      </v-combobox>
                    </template>
                    {{ $t("travelService.chooseOfferForm.costCentreTooltipAny") }}
                  </v-tooltip>
                </fieldset>
              </v-col>
              <v-col cols="12">
                <v-alert color="error darken-4" outlined>
                  {{ $t("travelService.chooseOfferForm.checkData.firstPart") }}
                  <span class="font-weight-bold">{{ $t("travelService.chooseOfferForm.checkData.boldPart") }}</span>
                  {{ $t("travelService.chooseOfferForm.checkData.thirdPart") }}
                  <router-link :to="'/travel-service/edit/' + $route.params.id">
                    {{ $t("travelService.chooseOfferForm.checkData.linkPart") }}
                  </router-link>
                  {{ $t("travelService.chooseOfferForm.checkData.fourthPart") }}
                </v-alert>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>

        <v-stepper-content :step="offer.items.length + 1">
          <h3>{{ $t("global.summary") }}</h3>

          <v-data-table
            :headers="summaryHeaders"
            :items="summaryDataTable"
            hide-default-footer
            :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
          >
            <template #item="props">
              <tr>
                <td>{{ props.item.name }} {{ props.item.selectedOption }}</td>
                <td class="">{{ props.item.selectedOptionCost }}</td>
              </tr>
            </template>
          </v-data-table>

          <h3>
            {{ $t("global.sum") }}:
            <template v-for="cost in summaryDataTableCost"> {{ cost.value }} {{ cost.currency }} </template>
            <template v-if="summaryDataTableCost.length === 0"> 0. {{ $t("travelService.noServicesSelectedToOrder") }} </template>
          </h3>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-card v-if="offer != null">
      <v-card-actions>
        <v-spacer />
        <v-btn @click.native="cancel()" color="blue darken-1" text v-if="stepper === 1">{{ $t("global.cancel") }}</v-btn>
        <v-btn @click.native="stepper--" color="blue darken-1" text v-if="stepper > 1">{{ $t("global.back") }}</v-btn>
        <v-btn @click.native="stepper++" color="blue darken-1" text v-if="stepper <= offer.items.length">{{ $t("global.next") }}</v-btn>
        <v-btn :disabled="$store.getters['Ajax/loading']" @click.native="save()" color="blue darken-1" text v-if="stepper === offer.items.length + 1">
          {{ $t("global.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { settingTypes } from "../../staticData/SettingsTypes";
import HotelResponsePresentation from "../../components/TravelService/OfferPresentation/HotelResponsePresentation";
import CarResponsePresentation from "../../components/TravelService/OfferPresentation/CarResponsePresentation";
import FlightResponsePresentation from "../../components/TravelService/OfferPresentation/FlightResponsePresentation";
import RailResponsePresentation from "../../components/TravelService/OfferPresentation/RailResponsePresentation";
import TravelUsersInlineForm from "../../components/TravelService/TravelUsersInlineForm";
import WYSIWYGHtmlElement from "../../components/Shared/WYSIWYGHtmlElement";
import ClientViewOfferHistory from "../../components/TravelService/ClientViewOfferHistory";
import MessageList from "../../components/MessageList";
import SeparateTravelService from "../../repository/SeparateTravelService";

export default {
  name: "TravelServiceChoseOfferView",
  components: {
    MessageList,
    ClientViewOfferHistory,
    WYSIWYGHtmlElement,
    TravelUsersInlineForm,
    RailResponsePresentation,
    FlightResponsePresentation,
    CarResponsePresentation,
    HotelResponsePresentation
  },
  data: () => ({
    offer: null,
    stepper: 1,
    availableUsers: [],
    isValid: null,
    settingTypes
  }),
  created() {
    this.axios
      .get("/travel-service/get-offer", {
        params: { id: this.$route.params.id }
      })
      .then(resp => {
        let data = JSON.parse(JSON.stringify(resp.data));
        for (let item of data.items) {
          item.selectedOffer = null;
          item.returnSelectedOffer = null;
          item.isValid = null;
        }
        this.offer = data;
      });
    this.axios.get("/travel-service/get-available-users").then(resp => {
      this.availableUsers = resp.data;
    });
  },
  computed: {
    summaryHeaders() {
      return [
        { text: this.$t("global.name"), value: "name", sortable: false },
        { text: this.$t("global.price"), value: "value", sortable: false }
      ];
    },
    summaryDataTable() {
      let result = [];
      if (this.offer == null) return result;
      for (let offerItem of this.offer.items) {
        let selectedOptionItem = offerItem.offers.find(v => v.id === offerItem.selectedOffer);
        let summaryItem = {
          name: this.$t("travelService.types." + offerItem.type),
          selectedOption: offerItem.selectedOffer === null ? "(nie wybrano)" : offerItem.selectedOffer === 0 ? "(rezygnacja z usługi)" : null,
          selectedOptionCost: typeof selectedOptionItem == "undefined" ? "---" : selectedOptionItem.price + " " + selectedOptionItem.currency
        };
        result.push(summaryItem);
      }
      return result;
    },
    summaryDataTableCost() {
      let result = [];
      if (this.offer == null) return result;
      for (let offerItem of this.offer.items) {
        let selectedOptionItem = offerItem.offers.find(v => v.id === offerItem.selectedOffer);
        if (typeof selectedOptionItem != "undefined") {
          let oldCurrencyRow = result.find(v => v.currency === selectedOptionItem.currency);
          if (typeof oldCurrencyRow != "undefined") {
            oldCurrencyRow.value += selectedOptionItem.price;
          } else {
            result.push({
              currency: selectedOptionItem.currency,
              value: selectedOptionItem.price
            });
          }
        }
      }
      return result;
    },
    costCentresRules() {
      return [
        v =>
          this.$store.state.Auth.userProperties.system_settings.cost_centre_on_delegations !== this.settingTypes.REQUIRED ||
          (v != null && v.length > 0) ||
          this.$t("global.error.required")
      ];
    },
    costCentres() {
      let result = [];
      for (let user of this.availableUsers) {
        for (let cost_centre of user.costCentres) {
          if (result.filter(v => v === cost_centre.name).length === 0) {
            result.push(cost_centre.name);
          }
        }
      }
      return result;
    },
    userList() {
      let result = [];
      for (let user of this.availableUsers) {
        result.push({ text: user.name + " " + user.surname, value: user.id });
      }
      return result;
    }
  },
  methods: {
    SeparateTravelService,
    downloadAvailableUsers() {
      this.axios.get("/travel-service/get-available-users").then(resp => {
        this.availableUsers = resp.data;
      });
    },
    removeCancelRequestSelection(item) {
      if (item.selectedOffer === 0) {
        item.selectedOffer = null;
      }
    },
    stepValidation(item) {
      let refName = "form" + this.offer.items.indexOf(item);
      if (item.selectedOffer != null && typeof this.$refs[refName] !== "undefined") {
        if (item.offers.filter(v => v.is_return_route === 1).length === 0 || item.returnSelectedOffer != null) return item.isValid;
      }
      return "notValid";
    },
    typeName(type) {
      if (type === "hotel") return "zakwaterowania";
      if (type === "rail") return "transportu kolejowego";
      if (type === "flight") return "transportu lotniczego";
      if (type === "car") return "wynajmu pojazdu";
      return "specjalna";
    },
    cancel() {
      this.$router.push("/travel-service");
    },
    validateThisItemForm(item) {
      let refName = "form" + this.offer.items.indexOf(item);
      this.$refs[refName][0].validate();
    },
    validateAll() {
      for (let item of this.offer.items) {
        let refName = "form" + this.offer.items.indexOf(item);
        if (item.selectedOffer != null && typeof this.$refs[refName] !== "undefined") {
          this.$refs[refName][0].validate();
        }

        if (this.stepValidation(item) !== true) {
          return false;
        }
      }
      return true;
    },
    save() {
      let offerShort = {};
      offerShort.items = [];
      offerShort.id = this.offer.id;
      for (let item of this.offer.items) {
        offerShort.items.push({
          selectedOffer: item.selectedOffer,
          id: item.id,
          cost_centre: item.cost_centre,
          returnSelectedOffer: item.returnSelectedOffer,
          users: item.users
        });
      }
      if (this.validateAll() === true) {
        this.axios.post("/travel-service/choose-offer", { offer: offerShort }).then(() => {
          this.$router.push("/travel-service");
        });
      } else {
        this.$store.dispatch("snackbarPush", {
          text: this.$t("travelService.chooseOfferForm.fillRequiredFieldsFirst"),
          color: "error",
          position: "down"
        });
      }
    },
    getRequiredProps(orderItem) {
      let result = {
        is_birth_date_required: 0,
        is_document_number_required: 0,
        is_document_expire_required: 0,
        is_email_required: 0,
        is_phone_required: 0,
        is_middle_name_required: 0,
        is_nationality_required: 0,
        is_document_issue_place_required: 0,
        is_residence_address_required: 0
      };
      if (orderItem.selectedOffer !== null && orderItem.selectedOffer !== 0) {
        let offer = orderItem.offers.find(v => v.id === orderItem.selectedOffer);
        for (let propertyName in result) {
          result[propertyName] = offer[propertyName];
        }
      }
      if (orderItem.returnSelectedOffer !== null && orderItem.returnSelectedOffer !== 0) {
        let offer = orderItem.offers.find(v => v.id === orderItem.returnSelectedOffer);
        for (let propertyName in result) {
          result[propertyName] = offer[propertyName] === 1 ? 1 : result[propertyName];
        }
      }

      return result;
    }
  }
};
</script>

<style scoped></style>
